import jsCookie from 'js-cookie'
import Vue from 'vue'
import { Message } from 'element-ui'
import store from '@/store/index.js';
// 创建WebSocket全局对象
export const ws = {
  socket: null,
  url: null,
  // 心跳包定时器
  heartbeatTimer: null,
  globalCallBack: null,
  // 初始化WebSocket连接
  connectWebSocket(callback) {
    this.globalCallBack = callback
    try {
      let memberId = jsCookie.get('wsmemberId')
      this.url = Vue.prototype.$websocketurl+'onlineService/1/' + memberId
      if (this.socket == null) {
        this.socket = new WebSocket(this.url)
        // 监听WebSocket连接打开事件
        this.socket.addEventListener('open', (event) => {
          console.log('WebSocket连接成功')
          // 启动心跳包定时器
          this.startHeartbeat()
        })
        // 监听WebSocket返回消息事件
        this.socket.addEventListener('message', (event) => {
          console.log('收到消息：', event.data)
          let onlineDialog=localStorage.getItem('onlineDialog');
          if (this.globalCallBack && typeof this.globalCallBack == 'function') {
            this.globalCallBack(JSON.parse(event.data))
          }
          if (JSON.parse(event.data).type == 0) {
            //说明以前有连接把以前的踢掉
            this.closeWebsocket()
          }
          if(JSON.parse(event.data).type != 0){
            if(onlineDialog&&onlineDialog==0){
              console.log('有消息出现，在线客户窗口没有打开，需要显示红点,当前uid值为:'+memberId);
              store.commit("changeIsMessage", 1);
            }else{
              store.commit("changeIsMessage", 0);
            }
          }
        })
        // 监听WebSocket连接关闭事件
        this.socket.addEventListener('close', (event) => {
          console.log('WebSocket连接已关闭')
          // 停止心跳包定时器
          this.stopHeartbeat()
          // 重新连接WebSocket
          //this.reconnect()
        })
        // 监听WebSocket连接错误事件
        this.socket.addEventListener('error', (event) => {
          console.error('WebSocket连接出错', event)
        })
      }
    } catch (e) {
      // 停止心跳包定时器
      this.stopHeartbeat()
      // 重新连接WebSocket
      this.reconnect()
    }
  },
  // 发送消息
  sendWebSocketMessage(message) {
    if (this.socket && this.socket.readyState === WebSocket.OPEN) {
      this.socket.send(JSON.stringify(message))
    } else {
      // 重新连接WebSocket
      this.reconnect()
    }
  },
  // 处理WebSocket返回的消息
  handleMessage(message) {
    // 处理消息
  },
  // 启动心跳包定时器
  startHeartbeat() {
    this.heartbeatTimer = setInterval(() => {
      console.log('每30s发送一次心跳包')
      // 发送心跳包
      this.sendHeartbeat()
    }, 30000)
  },
  // 停止心跳包定时器
  stopHeartbeat() {
    clearInterval(this.heartbeatTimer)
    this.heartbeatTimer = null
  },
  closeWebsocket() {
    if (this.socket) {
      console.log('手动关闭websocket')
      this.socket.close() // 关闭websocket
      this.socket = null
      this.stopHeartbeat() // 停止发送心跳包
    }
  },
  // 发送心跳包
  sendHeartbeat() {
    // 发送心跳包
    this.socket.send(1) // 发送心跳包
  },
  // 重新连接WebSocket
  reconnect() {
    // Message({
    //     message: '长时间未操作，当前连接已断开，稍后刷新重连',
    //     type: 'error',
    //     duration: 3 * 1000
    // })
    // location.reload();
    setTimeout(() => {
      this.connectWebSocket()
    }, 5000)
  },
}



// WEBPACK FOOTER //
// ./src/utils/websocket.js